import { iframeLocalStorage } from './iframeLocalStorage';

/**
 * Best-effort read of the respondent's current language code, used by
 * translation helpers that need to pick the right localised string.
 *
 * Resolution order:
 *   1. `current_project_language_code{suffix}` in iframeLocalStorage —
 *      set by ConsentScreen once the respondent confirms their language.
 *   2. `navigator.language` root code (e.g. "fr-FR" → "fr"), if
 *      available on the current platform.
 *   3. Falls back to `'en'`.
 *
 * Pass `projectStorageSuffix` when the consumer has it (hooks inside
 * the chat loop already receive the suffix). Omit it for surfaces
 * rendered before the respondent has a project context (error
 * boundary, redirected-error page).
 */
export function getLanguageCode(projectStorageSuffix = ''): string {
  const stored = iframeLocalStorage.getItem(
    `current_project_language_code${projectStorageSuffix}`,
  );
  if (stored) return stored;

  if (typeof navigator !== 'undefined' && navigator.language) {
    // navigator.language returns e.g. "en-US", "zh-TW", "pt-BR". Keep
    // the region-specific form for canonical codes that have one
    // (zh-TW) and drop the region otherwise ("en-US" → "en").
    const raw = navigator.language;
    if (raw === 'zh-TW') return 'zh-TW';
    return raw.split('-')[0];
  }

  return 'en';
}
